module.exports = __webpack_public_path__ + "img/icon-marker-accent-6.13c77377.svg";